<template>
  <v-row>
    <v-col offset="0" cols="12" md="6" offset-lg="2" class="d-flex">
      <div class="indicador-icon">
        <v-icon color="#332de6" size="50">{{icon}}</v-icon>
      </div>
      <div class="pl-6">
        <h4 class="app-subtitle indicador-title pb-4">{{title}}</h4>
        <div>{{text}}</div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    text: String,
    icon: String,
    title: String
  }
}
</script>

<style>
.indicador-icon {
  color: #332de6;
}
.indicador-article {
  max-width: 1280px;
}
.indicador-title {
  color: #332de6;
  font-size: 24px;
}
</style>